<template>
  <div class="cke_container" ref="container" :disabled="readonly"></div>
</template>

<script>
  import CKEditorLoader from 'vendor/ckeditor/loader'
  import SnippetsPlugin from './plugins/snippets'
  import PersonalizationPlugin from './plugins/personalization'
  import EmojisPlugin from './plugins/emojis'
  import PreferencesPlugin from './plugins/preferences'

  export default {
    name: 'ck-editor',
    props: {
      content: String,
      fullPage: {
        type: Boolean,
        default: true
      },
      allowedContent: {
        type: Boolean,
        default: true
      },
      onChange: Function,
      readonly: {
        required: false,
        type: Boolean,
        default: false
      }
    },

    created () {
      this.loadEditor()
      window.addEventListener('resize', this.resizeEditor)
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.resizeEditor)
      this.editor && this.editor.destroy()

      const sourceButton = document.querySelector('.cke_toolgroup a.cke_button__source');

      sourceButton && sourceButton.removeEventListener('click', () => {
        this.handleSourceButtonClick();
      });
    },

    methods: {
      updatedContent () {
        return this.editor.getData()
      },

      loadEditor () {
        if (this.editor) return

        CKEditorLoader.load().then(CKEditor => {
          CKEditor.config.readOnly = this.readonly;
          CKEditor.config.versionCheck = false;

          let registeredPluginsKeys = Object.keys(CKEditor.plugins.registered)

          if (!registeredPluginsKeys.includes('snippets')) {
            CKEditor.plugins.add('snippets', SnippetsPlugin);
          }
          if (!registeredPluginsKeys.includes('personalization')){
            CKEditor.plugins.add('personalization', PersonalizationPlugin);
          }
          if (!registeredPluginsKeys.includes('emojis')) {
            CKEditor.plugins.add('emojis', EmojisPlugin);
          }
          if (!registeredPluginsKeys.includes('preferences')){
            CKEditor.plugins.add('preferences', PreferencesPlugin);
          }

          const editor = this.editor = CKEditor.appendTo(this.$refs.container, {
            fullPage: this.fullPage,
            enterMode: CKEditor.ENTER_BR,
            entities: false,
            allowedContent: this.allowedContent,
            removePlugins: 'about,elementspath,magicline',
            height: '100%',
            width: '100%',
            extraPlugins: 'snippets,personalization,emojis,preferences',
            toolbar: [
              [
                'Source', '-',
                'Cut', 'Copy', 'Paste', 'PasteText', '-',
                'Undo', 'Redo', '-',
                'Bold', 'Italic', 'RemoveFormat', '-',
                'NumberedList', 'BulletedList', 'Outdent', 'Indent', '-',
                'Link', 'Unlink', '-',
                'Image', '-',
                'Emojis', 'Personalization', 'Preferences', 'Snippets', '-'
              ]
            ]
          })
          editor.on('instanceReady', () => {
            this.resizeEditor()
            if (this.content) {
              this.initContent(this.content)
            }

            const sourceButton = document.querySelector('.cke_toolgroup a.cke_button__source');

            sourceButton && sourceButton.addEventListener('click', () => {
                this.handleSourceButtonClick();
              });
          })

          editor.on('change', () => {
            this.isChanged = true
            if (this.onChange) {
              this.onChange()
            }
          })
        })
      },

      handleSourceButtonClick() {
        this.$emit('source-btn');
      },

      initContent (content) {
        if (this.editor) {
          this.editor.setData(content, {
            noSnapshot: true
          })
        }
      },

      resizeEditor () {
        const width = this.$refs.container.offsetWidth
        const height = this.$refs.container.offsetHeight

        this.editor && this.editor.resize(width, height, false)
      }
    }
  }
</script>

<style>
  .cke_container {
    height: 100%;
    width: 100%;
  }
  .cke_dialog input {
    height: auto !important;
    line-height: normal !important;
  }
</style>



// WEBPACK FOOTER //
// vendor/ckeditor/editor.vue